import { apiConfig } from '../config/api';
import { ExportConfig, ExportResult } from '../types';

class ExportService {
  async exportReport(
    deckId: string,
    config: ExportConfig,
    token: string
  ): Promise<ExportResult> {
    const response = await fetch(`${apiConfig.baseUrl}${apiConfig.endpoints.export(deckId)}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(config),
    });

    if (!response.ok) {
      throw new Error('Failed to export report');
    }

    const data = await response.json();
    return data.data;
  }

  async getExportStatus(
    reportId: string,
    token: string
  ): Promise<any> {
    const response = await fetch(
      `${apiConfig.baseUrl}/api/reports/${reportId}/status`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch export status');
    }

    const data = await response.json();
    return data.data;
  }

  async pollExportStatus(
    reportId: string,
    token: string,
    onProgress?: (progress: number) => void,
    maxAttempts: number = 60, // 60 attempts * 2 seconds = 2 minutes max
    pollInterval: number = 2000 // 2 seconds
  ): Promise<ExportResult> {
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      const status = await this.getExportStatus(reportId, token);
      
      if (onProgress && status.progress !== undefined) {
        onProgress(status.progress);
      }

      if (status.status === 'completed') {
        return status;
      }

      if (status.status === 'failed') {
        throw new Error(status.error || 'Export failed');
      }

      // Wait before next poll
      await new Promise(resolve => setTimeout(resolve, pollInterval));
    }

    throw new Error('Export timeout - please try again');
  }

  downloadReport(downloadUrl: string): void {
    window.open(downloadUrl, '_blank');
  }
}

export const exportService = new ExportService();
export default ExportService;

